export enum RequestStatusEnum {
  Draft = 1,
  Submitted = 2,
  PendingPayment = 3,
  Cancelled = 4,
  InProgress = 5,
  Completed = 6,
  PendingAssignApprove = 7,
  PendingAuditAssign = 8,
  InAuditProgress = 9,
  ReturnedFromAudit = 10,
  CancellationInProgress = 11,
  OrderRejected=12,
  Approved=13,
  PendingReceivedAsset=14,
  PendingReceivedAssetAssign=15,
  AssetReceived =16
}
